export const StorageKeys = {
  token: 'accessToken',
};

const formatStorageValue = (val) => {
  try {
    return JSON.parse(val);
  } catch {
    return val;
  }
};

export const getStorageItem = (key) =>
  formatStorageValue(localStorage.getItem(key));

export const setStorageItem = (key, valueToStore) => {
  return localStorage.setItem(
    key,
    typeof valueToStore === 'string' // If the value is a string, we don't need to stringify it
      ? valueToStore
      : JSON.stringify(valueToStore),
  );
};

export const removeStorageItem = (key) => localStorage.removeItem(key);
